import type { SVGProps } from "react";

export default function ArrowRightUpIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <path
        d="M1.17651 10.9995L11.1765 0.999512M11.1765 0.999512H3.67651M11.1765 0.999512V8.49951"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
